import React from 'react';

import { amenityConfig } from '../../../configs/amenityConfig';

import CatalogItemResultsContainer from './CatalogItemResultsContainer';

export default function AccommodationAmenitiesResultsContainer() {
  return <CatalogItemResultsContainer config={amenityConfig} />;
}
